/**
 * Shared validation patterns.
 *
 * Canonical regex used across feature packages for form validation. Promoted
 * here once a second feature package needed the same pattern — keep additions
 * to genuinely cross-cutting patterns (a regex used by only one feature belongs
 * in that feature's own `lib.ts`).
 */

/**
 * Person name: one or more letters, separated by single spaces. No digits,
 * punctuation, or leading/trailing whitespace.
 *
 * @example "Mary Jane".match(NAME_REGEX) // ok
 * @example "Anne-Marie".match(NAME_REGEX) // null (hyphen)
 */
export const NAME_REGEX = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;

/**
 * Loose email shape check (local-part @ domain . tld). Validates structure
 * only — it does not verify the TLD is real. Pair with a stricter async TLD
 * lookup at the app layer when deliverability matters.
 */
export const EMAIL_REGEX = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

/** Singapore postal code: exactly six digits. */
export const POSTAL_CODE_REGEX = /^\d{6}$/;
